var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'router-link' : 'button',_vm._b({tag:"component",class:_vm.cn(
    'shrink-0 whitespace-nowrap inline-flex items-center justify-center px-[12px] py-[4px] rounded-[8px] text-[#0A0A0A] text-[14px] transition-all duration-[150ms] cursor-pointer focus:outline-none select-none',
    _vm.computedIsActive
      ? 'bg-white shadow-[0px_1px_3px_0px_#0000001A] hover:text-[#0A0A0A] font-medium'
      : 'hover:bg-[#E5E5E5] hover:text-[#0A0A0A]',
    _vm.$props.class
  ),attrs:{"to":_vm.to || undefined,"replace":_vm.replace},on:{"click":function($event){!_vm.to && _vm.tabsState && _vm.tabsState.setActive(_vm.value)}}},'component',_vm.to ? {} : {},false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }